<template>
  <div id="content" class="app-content">
    <!-- page header -->
    <b-row>
      <b-col>
        <h1 class="page-header">CSV Codes Batch <small>all listings.</small></h1>
      </b-col>

      <b-col sm="auto" class="ml-auto">
        <b-button :disabled="$cannot('supplier.manage')" v-b-modal.newCSVCodeBatch> New Batch </b-button>

        <b-modal
          title="New Code Batch"
          id="newCSVCodeBatch"
          hide-footer
          v-slot:default="{ close }"
          :no-close-on-backdrop="true"
        >
          <csv-codes-batch-form @close="refresh(close)" />
        </b-modal>
      </b-col>
    </b-row>

    <!-- page content -->
    <b-card>
      <div class="row">
        <div class="col-md-1">
          <b-form-group label="Show expired">
            <b-form-checkbox v-model="expired" @change="loadContent" />
          </b-form-group>
        </div>
        <div class="col-md-1">
          <b-form-group label="Show used">
            <b-form-checkbox v-model="used" @change="loadContent" />
          </b-form-group>
        </div>
      </div>


      <b-table :fields="fields" :items="listing" show-empty stacked="sm" bordered hover id="csv-codes-batch-table">
        <template v-slot:cell(actions)="row">
            <b-button class="btn-block" variant="default" size="sm" v-b-modal="`editCSVCodeBatch-${row.item.id}`"> View </b-button>
            <b-modal title="Edit Batch Details" :id="`editCSVCodeBatch-${row.item.id}`" hide-footer no-close-on-backdrop v-slot:default="{ close }">
                <csv-codes-batch-edit-form :batch="row" @close="refresh(close)" />
            </b-modal>

            <div v-if="row.item.deleted_at">
                <small class="text-danger text-center">Deleted</small>
            </div>
            <div v-else>
                <b-button class="btn-block" variant="danger" size="sm" v-b-modal="`deleteCSVCodeBatch-${row.item.id}`"> Delete </b-button>
                <b-modal :id="`deleteCSVCodeBatch-${row.item.id}`" hide-footer no-close-on-backdrop>
                    <validation-observer v-slot="{ invalid }">
                        <form @submit.prevent="deleteBatch(row.item.id)">
                            <h5 v-if="row.item.used_codes > 0" class="text-center">
                                This batch carries used codes ({{ row.item.used_codes }} codes), are you sure you want to delete this batch #{{ row.item.id }}?
                            </h5>
                            <h5 v-else class="text-center">Are you sure you want to delete batch: #{{ row.item.id }}?</h5>
                            <b-row align-h="center">
                                <b-col cols="auto">
                                    <b-button type="submit" variant="danger" :disabled="$cannot('supplier.manage') || invalid"> Delete </b-button>
                                </b-col>
                            </b-row>
                        </form>
                    </validation-observer>
                </b-modal>
            </div>
        </template>
      </b-table>

      <!-- pagination -->
      <b-pagination
        v-model="meta.current_page"
        :total-rows="meta.total"
        :per-page="meta.per_page"
        @change="paginationChange"
      />
    </b-card>
  </div>
</template>

<script>
import { products } from '@/api'
import CsvCodesBatchForm from './CSVCodesBatchForm'
import CsvCodesBatchEditForm from './CSVCodesBatchEditForm'
import dayjs from 'dayjs'

export default {
  name: 'CSVCodes',
  inject: ['$cannot'],
  components: { CsvCodesBatchForm, CsvCodesBatchEditForm },
  data() {
    return { listing: [], meta: {}, expired: false, used: false }
  },
  computed: {
    fields() {
      return [
        { key: 'id', label: 'ID' },
        { key: 'supplier', label: 'Supplier' },
        { key: 'title', label: 'Code Batch Name' },
        { key: 'num_codes', label: 'Codes' },
        { key: 'used_codes', label: 'Used' },
        { key: 'alert_when' },
        { key: 'end_time', formatter: (date) => dayjs(date).format('DD.MM.YYYY HH:mm:ss') },
        { key: 'Actions' },
      ]
    },
  },

  beforeRouteEnter(from, to, next) {
    next((vm) => vm.loadContent())
  },

  methods: {
    async loadContent() {
      const page = this.$route.query.page ?? 1
      const response = await products.variations.batches.go(page, {
        filter: {
          expired: this.expired,
          used: this.used,
        },
      })

      this.$nextTick(() => {
        this.listing = response.data().map((data) => {
          return { ...data }
        })

        this.meta = response.meta
      })
    },

    paginationChange(page) {
      this.$router.push(page === 1 ? { name: 'csvcodes' } : { name: 'csvcodes', query: { page } })

      this.loadContent()
    },

    refresh(callback) {
      this.loadContent()
      callback()
    },

    async deleteBatch(id) {
        await this.$store.dispatch('auth/refreshToken');
        await products.variations.batches.destroy(id)

        this.loadContent()

        this.$bvToast.toast(`Batch deleted.`, {
            title: 'Batch deleted',
            variant: 'primary',
        })
        this.$bvModal.hide("deleteCSVCodeBatch-" + id)

        this.$emit('close')
    }
  },
}
</script>
